// project imports
import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
import MainLayout from 'layout/MainLayout';
import ProtectedRoute from 'component/ProtectedRoute';
import Dashboard from 'views/dashboard/dashboard';
import Blog from 'views/blog/blog';
import AddBlog from 'views/blog/add-blog';
import EditBlog from 'views/blog/edit-blog';
import Inquiry from 'views/inquiry/inquiry';
import AddRole from 'views/role/add-role';
import EditRole from 'views/role/edit-role';
import RoleManagement from 'views/role/role-management';
import SystemConfiguration from 'views/systemConfiguration/system-configuration';
import AddUser from 'views/user/add-user';
import EditUser from 'views/user/edit-user';
import AdminUserManagement from 'views/user/admin-user-management';
import CustomerManagement from 'views/customer/customer-managment';
import Subscriptions from 'views/subscriptions/subscriptions';
import AddCustomer from 'views/customer/add-customer';
import EditCustomer from 'views/customer/edit-customer';
import WillManagement from 'views/will-management/will-management';
import Contact from 'views/contact/contact';
import AddContact from 'views/contact/add-contact';
import EditContact from 'views/contact/edit-contact';
import PlanManagement from '../views/plan/plan-management';
import AddPlan from '../views/plan/add-plan';
import EditPlan from '../views/plan/edit-plan';
import CouponManagement from 'views/coupon/coupon-managment';
import AddCoupon from 'views/coupon/add-coupon';
import EditCoupon from 'views/coupon/edit-coupon';
import Calculators from 'views/Calculators/Calculators';
import Accounts from 'views/accounts/accounts';
import SupportTickets from 'views/support/supportTickets';
import Marketing from 'views/marketing/marketing';
import Template from 'views/marketing/template/template';
import Subscriber from 'views/marketing/subscriber/subscriber';
import AddTemplate from 'views/marketing/template/add-template';
import EditTemplate from 'views/marketing/template/edit-template';
import Campaign from 'views/marketing/campaign/campaign';
import AddCampaign from 'views/marketing/campaign/add-campaign';
import EditCampaign from 'views/marketing/campaign/edit-campaign';
import Unauthorized from 'views/unauthorized/Unauthorized';
import { MODULE_KEYS } from 'store/constant';
import { useEffect } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';

// ==============================|| MAIN ROUTING ||============================== //


const ProtectedAuthRoute = ({ children }) => {
  const { instance, inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthenticated && inProgress === "none") {
      instance.loginRedirect();
    }
  }, [isAuthenticated, inProgress, instance]);

  if (!isAuthenticated) return null;

  return children;
};

const AppRoutes = () => {
  return (
    <ProtectedAuthRoute>
      <MainLayout></MainLayout>
    </ProtectedAuthRoute>
  );
};

const MainRoutes = {
  path: '/',
  element: <AppRoutes />,
  children: [
    {
      path: '/',
      element: (
        <ProtectedRoute moduleKey={MODULE_KEYS.Dashboard}>
          <Dashboard />
        </ProtectedRoute>
      )
    },
    {
      path: '/unauthorized',
      element: <Unauthorized />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Dashboard}>
              <Dashboard />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'admin-user-management',
      children: [
        {
          path: '/admin-user-management',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.User_Management}>
              <AdminUserManagement />
            </ProtectedRoute>
          )
        },
        {
          path: 'add-user',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.User_Management} requireWrite={true}>
              <AddUser />
            </ProtectedRoute>
          )
        },
        {
          path: 'edit-user/:id',
          element: (
            <ProtectedAuthRoute moduleKey={MODULE_KEYS.User_Management}>
              <EditUser />
            </ProtectedAuthRoute>
          )
        }
      ]
    },
    {
      path: 'role-management',
      children: [
        {
          path: '/role-management',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Role_Management}>
              <RoleManagement />
            </ProtectedRoute>
          )
        },
        {
          path: 'add-role',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Role_Management} requireWrite={true}>
              <AddRole />
            </ProtectedRoute>
          )
        },
        {
          path: 'edit-role/:id',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Role_Management}>
              <EditRole />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'plan-management',
      children: [
        {
          path: '/plan-management',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Plan_Management}>
              <PlanManagement />
            </ProtectedRoute>
          )
        },
        {
          path: 'add-plan',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Plan_Management} requireWrite={true}>
              <AddPlan />
            </ProtectedRoute>
          )
        },
        {
          path: 'edit-plan/:id',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Plan_Management} requireWrite={true}>
              <EditPlan />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'calculators',
      children: [
        {
          path: '/calculators',
          element: (
            <ProtectedRoute moduleKey="calculators">
              <Calculators />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'marketing',
      children: [
        {
          path: 'subscriber',
          element:
            <ProtectedRoute moduleKey={MODULE_KEYS.Subscriber}>
              <Subscriber />
            </ProtectedRoute>
        },
        {
          path: 'template',
          element: 
          <ProtectedRoute moduleKey={MODULE_KEYS.Template}>
            <Template />
          </ProtectedRoute>
        },
        {
          path: 'add-template',
          element: 
          <ProtectedRoute moduleKey={MODULE_KEYS.Template} requireWrite={true}>
            <AddTemplate />
          </ProtectedRoute>
        },
        {
          path: 'edit-template/:id',
          element: 
          <ProtectedRoute moduleKey={MODULE_KEYS.Template}>
            <EditTemplate />
          </ProtectedRoute>
        },
        {
          path: 'campaign',
          element: 
          <ProtectedRoute moduleKey={MODULE_KEYS.Campaign}>
            <Campaign />
          </ProtectedRoute>
        },
        {
          path: 'add-campaign',
          element: 
          <ProtectedRoute moduleKey={MODULE_KEYS.Campaign} requireWrite={true}>
            <AddCampaign />
          </ProtectedRoute>
        },
        {
          path: 'edit-campaign/:id',
          element: 
          <ProtectedRoute moduleKey={MODULE_KEYS.Campaign}>
            <EditCampaign />
          </ProtectedRoute>
        },
      ]
    },
    {
      path: 'system-configuration',
      children: [
        {
          path: '/system-configuration',
          element: (
            <ProtectedRoute moduleKey="systemConfiguration">
              <SystemConfiguration />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'customer-management',
      children: [
        {
          path: '/customer-management',
          element: (
            <ProtectedRoute moduleKey="customerManagement">
              <CustomerManagement />
            </ProtectedRoute>
          )
        },
        {
          path: 'add-customer',
          element: (
            <ProtectedRoute moduleKey="customerManagement" requireWrite={true}>
              <AddCustomer />
            </ProtectedRoute>
          )
        },
        {
          path: 'edit-customer/:id',
          element: (
            <ProtectedRoute moduleKey="customerManagement" requireWrite={true}>
              <EditCustomer />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'coupon-management',
      children: [
        {
          path: '/coupon-management',
          element: (
            <ProtectedRoute moduleKey="couponManagement">
              <CouponManagement />
            </ProtectedRoute>
          )
        },
        {
          path: 'add-coupon',
          element: (
            <ProtectedRoute moduleKey="couponManagement" requireWrite={true}>
              <AddCoupon />
            </ProtectedRoute>
          )
        },
        {
          path: 'edit-coupon/:id',
          element: (
            <ProtectedRoute moduleKey="couponManagement" requireWrite={true}>
              <EditCoupon />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'will-management',
      children: [
        {
          path: '/will-management',
          element: (
            <ProtectedRoute moduleKey="willManagement">
              <WillManagement />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'subscriptions',
      children: [
        {
          path: '/subscriptions',
          element: (
            <ProtectedRoute moduleKey="subscriptions">
              <Subscriptions />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'contact',
      children: [
        {
          path: '/contact',
          element: (
            <ProtectedRoute moduleKey="contacts">
              <Contact />
            </ProtectedRoute>
          )
        },
        {
          path: 'add-contact',
          element: (
            <ProtectedRoute moduleKey="contacts" requireWrite={true}>
              <AddContact />
            </ProtectedRoute>
          )
        },
        {
          path: 'edit-contact/:id',
          element: (
            <ProtectedRoute moduleKey="contacts" requireWrite={true}>
              <EditContact />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'blog',
      children: [
        {
          path: '/blog',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Blogs}>
              <Blog />
            </ProtectedRoute>
          )
        },
        {
          path: 'add-blog',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Blogs} requireWrite={true}>
              <AddBlog />
            </ProtectedRoute>
          )
        },
        {
          path: 'edit-blog/:id',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Blogs}>
              <EditBlog />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'inquiry',
      children: [
        {
          path: '/inquiry',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Inquiry}>
              <Inquiry />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'accounts',
      children: [
        {
          path: '/accounts',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Accounts}>
              <Accounts />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'support',
      children: [
        {
          path: '/support',
          element: (
            <ProtectedRoute moduleKey={MODULE_KEYS.Support}>
              <SupportTickets />
            </ProtectedRoute>
          )
        }
      ]
    }
  ]
};

export default MainRoutes;